import { ApiEndpointHandler } from '@sonar-software/sonar-http';
import { createGetFullKeyEndpointFromExisting } from '@lib';

import { getInitiativeTasks, GetInitiativeTasksRequest, GetInitiativeTasksResponse } from './getInitiativeTasks';

// Narrowed from the helper's `Partial` request so callers must still provide `initiativeId`.
export const getInitiativeTasksAll: ApiEndpointHandler<GetInitiativeTasksRequest, GetInitiativeTasksResponse> =
	createGetFullKeyEndpointFromExisting(getInitiativeTasks);
